// biome-ignore lint/style/noRestrictedImports: component usage
import { Trigger } from "@radix-ui/react-tabs";
import { cx } from "@suse-o11y/class-variance";
import React from "react";

import styles from "./_tabs.module.css";

export interface TabsTriggerProps extends React.ComponentPropsWithoutRef<typeof Trigger> {
	onDelete?: (value: string) => void;
}

export const TabsTrigger = React.forwardRef<React.ElementRef<typeof Trigger>, TabsTriggerProps>(
	({ className, onKeyDown, onDelete, children, ...props }, ref) => (
		<Trigger
			className={cx(styles.trigger, className)}
			onKeyDown={(event) => {
				onKeyDown?.(event);

				if (event.key === "Backspace" || event.key === "Delete") {
					onDelete?.(props.value);
				}
			}}
			ref={ref}
			{...props}
		>
			{children}
		</Trigger>
	),
);

if (import.meta.env.DEV) {
	TabsTrigger.displayName = Trigger.displayName;
}
